/* import __COLOCATED_TEMPLATE__ from './new-task-wrapper.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import type AppService from 'embercom/services/app-service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Template from 'embercom/models/template';

type Args = {
  onClose: () => void;
  templates: Template[];
  selectedTemplate: Template | null;
  selectedTemplateContentObject: any;
  disableTransitionBack: boolean;
  startFromScratchTemplate: Template;
  selectTemplate: (template: Template) => void;
  createNewTask: () => void;
  createTaskFromTemplate: () => void;
};

export default class NewTaskWrapper extends Component<Args> {
  @service declare appService: AppService;
  @service intercomEventService: any;
  @tracked activeModalView = this.activeModalViewFromParams;

  get activeModalViewFromParams() {
    if (this.args.selectedTemplate) {
      return 'templatePreview';
    } else {
      return 'templateSelector';
    }
  }

  get app() {
    return this.appService.app;
  }

  @action
  transitionToPreview() {
    this.activeModalView = 'templatePreview';
  }

  @action
  recordAnalyticsEvent(actionLabel: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: actionLabel,
      object: 'new_task_modal',
      place: this.activeModalView,
      context: 'task_list',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Outbound::NewContentModal::TaskTemplate::NewTaskWrapper': typeof NewTaskWrapper;
  }
}
